const moduleReturnsSel = (state: any) => state.returns;

export const partsToReturnSel = (state: any) =>
  moduleReturnsSel(state).partsToReturn;
export const eligibleDataSel = (state: any) =>
  moduleReturnsSel(state).eligibleData;
export const eligibleCoreDataSel = (state: any) =>
  moduleReturnsSel(state).eligibleCoreData;
export const statusDataSel = (state: any) => moduleReturnsSel(state).statusData;
export const rmaListSel = (state: any) => moduleReturnsSel(state).rmaList;
export const lastRMACodebarSel = (state: any) =>
  moduleReturnsSel(state).lastRMACodebar;

export const returnAlertSel = (state: any) =>
  moduleReturnsSel(state).returnAlert;
export const returnStatusAlertSel = (state: any) =>
  moduleReturnsSel(state).returnStatusAlert;
export const returnIsPendingSel = (state: any) =>
  moduleReturnsSel(state).isPending;
export const returnIsDownloadingPdfSel = (state: any) =>
  moduleReturnsSel(state).isDownloadingPdf;
export const returnErrorSel = (state: any) => moduleReturnsSel(state).error;
export const closeModalIfErrorSel = (state: any) =>
  moduleReturnsSel(state).isCloseModalIfError;
